import React from "react";
import DeviceBasedRenderer from "../../../components/common/DeviceBasedRenderer";
import PageAutodisplayViewLinkEduDesktop from "./PageAutodisplayViewLinkEduDesktop";
import PageAutodisplayViewLinkEduMobile from "./PageAutodisplayViewLinkEduMobile";

const PageAutodisplayViewLinkEdu = () => {
  console.log("🎯 기기별 컴포넌트 라우터 - PageAutodisplayViewLinkEdu");

  return (
    <DeviceBasedRenderer
      DesktopComponent={PageAutodisplayViewLinkEduDesktop}
      MobileComponent={PageAutodisplayViewLinkEduMobile}
      AndroidComponent={PageAutodisplayViewLinkEduMobile} // 안드로이드도 모바일 컴포넌트 사용
      IOSComponent={PageAutodisplayViewLinkEduMobile} // iOS도 모바일 컴포넌트 사용
    />
  );
};

export default PageAutodisplayViewLinkEdu;
